import type { EntityPermissionsMapper } from 'logic/permissions/EntityPermissionsMapper';
import EntityPermissionsMapperBinder from 'logic/permissions/EntityPermissionsMapper';

const supportedTypes = new Set(['report']);

const typePrefixCornerCasesMap = {
  report: 'report:',
};

const reportEntityPermissionsMapper: EntityPermissionsMapper = {
  mapForIdAndType(_id: string, _type: string): string | undefined {
    return undefined;
  },
  mapForType(type: string): string | undefined {
    if (supportedTypes.has(type)) return typePrefixCornerCasesMap[type] ?? `${type}s:`;

    return undefined;
  },
};

EntityPermissionsMapperBinder.register(reportEntityPermissionsMapper);

export default reportEntityPermissionsMapper;
